/**
 * HmConnection — pozycja „Połączenie" w menu modułu Handel i Magazyn.
 *
 * Osadza istniejący ekran integracji ERP zamiast budować drugi taki sam: połączenie z Symfonią
 * (adres, token aplikacji, test) jest jedno i to samo, niezależnie od tego, czy wchodzi się w nie
 * z Ustawień, czy z tego modułu. Duplikat oznaczałby dwa miejsca konfigurujące ten sam rekord.
 *
 * ŚWIADOME OGRANICZENIE: lista nie jest zawężona do integracji Handlu — pokazuje też FK, jeśli
 * firma ją ma. Zawężenie wymagałoby filtra w samej liście integracji, a rozstrzygnięcie „czy
 * konfiguracja połączenia należy do tego modułu, czy zostaje w Ustawieniach" jest tematem Fali 2.
 */

import { useTranslation } from 'react-i18next';

import { ErpIntegrationTabs } from '@/components/settings/ErpIntegrationTabs';

export function HmConnection() {
  const { t } = useTranslation();
  return (
    <div className="p-4">
      <h1 className="mb-3 text-xl font-semibold text-text-primary">
        {t('tenant.handelMagazyn.connection.title')}
      </h1>
      <ErpIntegrationTabs />
    </div>
  );
}

export default HmConnection;
